<script lang="ts">
  import {createEventDispatcher, onDestroy, onMount} from 'svelte';
  import editorInstance from '../../lib/editor/editor';
  import editorStore from '../../lib/editor/editor.store';
  import {createImageElement} from '../../lib/editor/helpers';
  import {getInstance} from '../../services/animation';
  import Icon from '../icon/Icon.svelte';
  import pixabayStore from './pixabay.store';
  import Result from './Result.svelte';
  let loading = true;
  let results: any[] = [];
  let spinnerEl: HTMLDivElement;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        console.log('Loading next page...');
        pixabayStore.loadNextPage();
      }
    });
  });

  function beginObservation(node: HTMLElement) {
    console.log('Observing node', node);
    observer.observe(node);
  }
  const unsubscribe = pixabayStore.subscribe(store => {
    console.log('update to store', store);
    loading = store.searching;
    if (store.results) results = store.results;
  });
  const addImageToEditor = (src: string) => {
    const imageDiv = createImageElement(src);
    editorInstance.addComponent(imageDiv, true);
  };
  const dispatch = createEventDispatcher();

  onMount(() => {
    if ((!$pixabayStore.results || !$pixabayStore.results.length) && !$pixabayStore.searching) {
      pixabayStore.search('Faith');
    }
  });

  onDestroy(unsubscribe);
</script>

{#if loading && !results.length}
  <div class="flex h-full w-full justify-center p-10 align-middle">
    <Icon name="Spinner" className=" text-gray-400  w-12 h-12 animate-spin" />
  </div>
{:else}
  <div class="grid grid-cols-2 gap-4">
    {#if results && results.length}
      {#each results as result}
        <Result imageUrl={result.previewURL} on:click={() => dispatch('select', {result})} />
      {/each}
      <div
        bind:this={spinnerEl}
        use:beginObservation
        class="col-span-2 flex h-full w-full flex-col justify-center p-10 text-center align-middle"
      >
        <div class="flex w-full items-center justify-center py-2">
          <Icon name="Spinner" className=" text-slate-400  w-12 h-12 animate-spin block" />
        </div>
        <span class="block w-full p-2 text-xs font-bold text-slate-400">Loading more images...</span>
      </div>
    {/if}
  </div>
{/if}
